import { UseFormRegisterReturn } from 'react-hook-form'

import { WidgetChoice } from '@/common/form/choice'

import Selector, { SelectorSize, SelectorType } from '@/components/view/atoms/selector/Selector'

export const FormSelectorValue = {
  BOOLEAN: 'boolean'
} as const

export type FormSelectorValue = (typeof FormSelectorValue)[keyof typeof FormSelectorValue]

interface Props {
  size?: SelectorSize
  type?: SelectorType
  choices: WidgetChoice<string | number>[]
  register: UseFormRegisterReturn
  value?: string | number
  error?: boolean
  noSelectable?: boolean
  disabled?: boolean
  noSelectName?: string
}

const FormSelector = ({
  choices,
  size = SelectorSize.AUTO,
  type = SelectorType.DEFAULT,
  register,
  value,
  error = false,
  noSelectable = false,
  disabled = false,
  noSelectName = '未選択'
}: Props) => {
  return (
    <Selector
      size={size}
      selectorType={type}
      name={register.name}
      choices={noSelectable ? [{ name: noSelectName, value: '' }, ...choices] : choices}
      error={error}
      value={value}
      required={register.required}
      onChange={register.onChange}
      inputRef={register.ref}
      disabled={register.disabled || disabled}
    />
  )
}

export default FormSelector
